// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"707":"e28d41d9","906":"487e98fc"}[chunkId] + ".css";
};